import { defineComponent } from '@vue/composition-api';
import { BfButton } from 'components/Butterfly';
import Modal from 'src/components/project/analysis/results/Modal.vue';
const ThemeDeleteModal = defineComponent({
    components: {
        BfButton,
        Modal,
    },
    props: {
        visible: { type: Boolean, required: true },
        groupName: { type: String, required: true },
    },
});
export default ThemeDeleteModal;
